import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, authHeaders } from "@/constants/roles";

const PermsContext = createContext({ role: null, permissions: {}, loaded: false, has: () => true });

export const PermsProvider = ({ children }) => {
  const [state, setState] = useState({ role: null, permissions: {}, loaded: false });

  useEffect(() => {
    axios
      .get(`${API}/my/permissions`, { headers: authHeaders() })
      .then((r) => setState({ role: r.data.role, permissions: r.data.permissions || {}, loaded: true }))
      .catch(() => setState((s) => ({ ...s, loaded: true })));
  }, []);

  // Optimistic while loading (backend enforces regardless) to avoid UI flicker
  const has = (key) => (state.loaded ? state.permissions?.[key] === true : true);

  return <PermsContext.Provider value={{ ...state, has }}>{children}</PermsContext.Provider>;
};

export const usePerms = () => useContext(PermsContext);
